import React, { useState, useEffect } from 'react'
import { Card, CardBody, FormGroup, Input, Label, Button } from 'reactstrap';
import styles from '../../../../assets/css/rstyling.module.css'
import { getActivity, createActivityQualityChecks } from '../../../../actions/activities_actions'
import { useDispatch } from 'react-redux'
import { useParams } from "react-router-dom";
import Select from 'react-select';
import Swal from 'sweetalert';


export default function QualityChecksScoring() {

    const dispatch = useDispatch()
    const [isCheckedloi, setIsCheckedloi] = useState(false);
    const [isCheckedAttention, setIsCheckedAttention] = useState(false);
    const [isCheckedProfile, setIsCheckedProfile] = useState(false);
    const [questions, setQuestions] = useState([])
    const params = useParams()
    const [range, setRange] = useState({
        start: 0,
        end: 0
    });

    const [allChecks, set_allChecks] = useState({
        loiRangeInSeconds: { min: 0, max: 0 },
        attention: { questionId: '', questionText: '', options: [] },
        profile: [{ questionId: '', questionText: '', profileQualityCheckType: '' }],


    })

    const [scoreWeights, setScoreWeights] = useState({
        indexOutOf: '',
        loi: '',
        attention: '',
        profile: ''
    });

    const [options, setOptions] = useState([])
    const handleChange = (e) => {
        const { name, value } = e.target;
        setRange(prev => ({
            ...prev,
            [name]: value
        }));

        const rangeObject = {
            min: Number(range.start),
            max: Number(range.end)
        };
        set_allChecks({
            ...allChecks,
            loiRangeInSeconds: rangeObject
        })
    };
    const [selectedOpt, setSelectedOpt] = useState([])
    const [selectedQuestionsProfile, set_selectedQuestionsProfile] = useState([])


    const handleCheckboxChangeLOI = (event) => {
        const checked = event.target.checked;
        setIsCheckedloi(checked);

        if (checked) {
            //addCategory();
        }
        if (!checked) {
            //clearCategory();
        }
    };

    const handleCheckboxChangeAttention = (event) => {
        const checked = event.target.checked;
        setIsCheckedAttention(checked);

        if (checked) {
            //addScript();
        }
        if (!checked) {
            //clearScript();
        }
    }
    const handleCheckboxChangeProfile = (event) => {
        const checked = event.target.checked;
        setIsCheckedProfile(checked);

        if (checked) {
            //addScript();
        }
        if (!checked) {
            //clearScript();
        }
    }

    const onSelectQuestion = (questionId) => {

        questions.map((question) => {

            if (question._id === questionId) {
                //setConditionQuestionType(question.questionType)
                setOptions(question.options)
                set_allChecks({ ...allChecks, attention: { questionId: question._id, questionText: question.questionText } })


            }
        }

        )

    }

    const onSelectOption = (option) => {
        setSelectedOpt(option)
        let finalOptions = option.map(option => option.value)
        set_allChecks({ ...allChecks, attention: { ...allChecks.attention, options: finalOptions } })

    }

    const onSelectQuestionProfile = (question) => {
        set_selectedQuestionsProfile(question)

        let finalQuestions = question.map((question) => {

            let profileQuestions = {
                questionId: question.value,
                questionText: question.label,
                profileQualityCheckType: question.type[0]
            }
            return profileQuestions
        })

        set_allChecks({ ...allChecks, profile: finalQuestions })
    }


    const handleWeightsChange = (e) => {
        const { name, value } = e.target;

        setScoreWeights(prev => ({
            ...prev,
            [name]: parseInt(value)
        }));

    };




    const submitAllChecks = () => {
        // start from here

        // console.log(allChecks)
        // console.log(scoreWeights)
        allChecks.scoreWeights = scoreWeights
        allChecks.activityType = 'Quick Survey'
        //console.log('all checks ->', allChecks)

        dispatch(createActivityQualityChecks(allChecks, params.activityid))
            .then(response => {
                if (response.payload.message === 'Quality Checks Created Successfully') {
                    Swal({
                        title: 'Created',
                        text: response.payload.message,
                        icon: 'success'
                    })
                }
            })
            .catch(err => {
                Swal({
                    title: "Error",
                    text: "Something went wrong",
                    icon: 'error'
                })
            })
    }

    useEffect(() => {
        dispatch(getActivity(params.activityid))
            .then(response => {


                setQuestions(response.payload.content.survey.pages[0].questions)
            })
            .catch(err => {
                console.log('')
            })


    }, [])


    return (
        <div style={{ minHeight: '10rem', height: 'auto' }}>

            <div className='d-flex flex-column my-4'>
                <div className='my-4'>
                    <input className='mx-4'
                        type="checkbox"
                        checked={isCheckedloi}
                        onChange={handleCheckboxChangeLOI}
                    />
                    <Label>Set Length of Interview Range (in seconds)</Label>
                </div>
                {/* {range.start > 0 && range.end > 0 && <div>{range.start}-{range.end}</div>} */}
                {isCheckedloi && <div className="mx-4 d-flex align-items-end">
                    <FormGroup className="flex-fill">
                        <Label for="startNumber">Start of Range (in seconds)</Label>
                        <Input
                            type="number"
                            name="start"
                            id="startNumber"
                            placeholder="Enter start value"
                            onChange={handleChange}
                            value={range.start}
                        />
                    </FormGroup>

                    <div className="pb-4 mx-3 fw-bold">—</div>

                    <FormGroup className="flex-fill">
                        <Label for="endNumber">End of Range (in seconds)</Label>
                        <Input
                            type="number"
                            name="end"
                            id="endNumber"
                            placeholder="Enter end value"
                            onChange={handleChange}
                            value={range.end}
                        />
                    </FormGroup>
                    {/* <Button className="ms-3" onClick={handleSubmit}>
                        Submit LOI
                    </Button> */}
                </div>}

                <div className='my-4'>
                    <input className='mx-4'
                        type="checkbox"
                        checked={isCheckedAttention}
                        onChange={handleCheckboxChangeAttention}
                    />
                    <Label>Set Attention Quality Check</Label>
                </div>
                {isCheckedAttention && <div className='mx-4'>

                    <Input type="select" name="questions" id="questions"
                        className={`form-control`}
                        onInput={(e) => onSelectQuestion(e.target.value)}
                    >
                        <option value="">Select a Question for Quality Check</option>

                        {
                            questions && questions.map((question, index) => {

                                return <option key={index} value={question._id}>{question.questionText && question.questionText != undefined ? question.questionText.replace(/<span>|<\/span>/g, '') : ''}</option>
                            })
                        }
                    </Input> </div>}
                {isCheckedAttention && options && options.length > 0 && <div className='m-4'>

                    <Select

                        isMulti
                        name="options"

                        options={options.map(opt => ({ value: opt, label: opt }))}
                        value={selectedOpt}
                        placeholder='Select options'
                        className="basic-multi-select"
                        classNamePrefix="Select"
                        onChange={onSelectOption}

                    />

                    {/* <Button className="my-4" onClick={submitAttentionCheck}>
                        Submit Attention Check
                    </Button> */}
                </div>

                }

                <div className='my-4'>
                    <input className='mx-4'
                        type="checkbox"
                        checked={isCheckedProfile}
                        onChange={handleCheckboxChangeProfile}
                    />
                    <Label>Set Profile Quality Check</Label>
                </div>

                {isCheckedProfile && <div className='mx-4'>
                    {/* {console.log('questions->', questions)} */}
                    <Select

                        isMulti
                        name="questions"
                        options={
                            questions.filter(opt => opt.profileCheckAge || opt.profileCheckEmail || opt.profileCheckGender).map((opt) => (
                                { value: opt._id, label: opt.questionText.replace(/<span>|<\/span>/g, ''), type: [opt.profileCheckAge && 'age', opt.profileCheckEmail && 'email', opt.profileCheckGender && 'gender'].filter(Boolean) }))
                        }
                        value={selectedQuestionsProfile}
                        placeholder='Select Questions'
                        className="basic-multi-select"
                        classNamePrefix="Select"
                        onChange={onSelectQuestionProfile}

                    />
                </div>}
                {isCheckedloi && isCheckedAttention && isCheckedProfile && <>
                    <label className='m-4' style={{ fontSize: '1rem', fontWeight: '500' }}>Weights Scoring:</label>
                    <div className="row mx-4">

                        <div className="col-3 form-group">
                            <label htmlFor="duration">Specify Index</label>
                            <Input type="number"
                                className={"form-control"}
                                name="indexOutOf"
                                placeholder="Index out of"
                                onChange={handleWeightsChange}
                                value={scoreWeights.indexOutOf}
                            />
                        </div>
                        <div className="col-3 form-group">
                            <label htmlFor="duration">LOI</label>
                            <Input type="number"
                                className={"form-control"}
                                name="loi"
                                placeholder="LOI Index"
                                onChange={handleWeightsChange}
                                //onBlur={handleBlur}
                                value={scoreWeights.loi}
                            />
                        </div>
                        <div className="col-3 form-group">
                            <label htmlFor="duration">Attention</label>
                            <Input type="number"
                                className={"form-control"}
                                name="attention"
                                placeholder="Attention Index"
                                onChange={handleWeightsChange}
                                //onBlur={handleBlur}
                                value={scoreWeights.attention}
                            />
                        </div>
                        <div className="col-3 form-group">
                            <label htmlFor="duration">Profile</label>
                            <Input type="number"
                                className={"form-control"}
                                name="profile"
                                placeholder="Profile Index"
                                onChange={handleWeightsChange}
                                //onBlur={handleBlur}
                                value={scoreWeights.profile}
                            />
                        </div>


                    </div>

                </>}

                {(isCheckedAttention && isCheckedloi && isCheckedProfile) && <div className="text-center my-4">
                    <Button className={`btn ${styles.bg_blue} text-white`} onClick={submitAllChecks}>Submit all quality checks</Button>
                </div>}

            </div>
        </div>
    )
}
